module.exports = __webpack_public_path__ + "static/img/oto.069eb87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oto.jpg
// module id = 0h13
// module chunks = 1